<script lang="ts" setup>
import { ref, watchEffect } from 'vue'
import type { CSSProperties } from 'vue'
import { getScreenType } from '/@/utils'
const props = defineProps<{
	modelValue: boolean
	title: string
	width?: string | number
	confirmLoading?: boolean
	confirmText?: string
	cancelText?: string
	contentStyle?: CSSProperties
	disabled?: boolean
	hideConfirm?: boolean
	hideCancel?: boolean
	hideFooter?: boolean
	appendToBody?: boolean
	isCanCelEvent?: boolean
}>()
const emits = defineEmits(['cancel', 'confirm', 'close', 'update:modelValue'])

const showDialog = ref(props.modelValue)

watchEffect(() => {
	showDialog.value = props.modelValue
})

watchEffect(() => {
	emits('update:modelValue', showDialog.value)
})

const cancel = () => {
	emits('cancel')
	if (props.isCanCelEvent) return
	showDialog.value = false
}
const confirm = () => {
	emits('confirm', cancel)
}
const close = () => {
	emits('close')
}
</script>

<template>
	<el-dialog
		v-model="showDialog"
		:title="title"
		:width="width || (getScreenType().IS_MOBILE ? '90%' : Number(width) || 480)"
		@close="close"
		:close-on-click-modal="false"
		:append-to-body="appendToBody"
	>
		<div class="dialog-content" :style="contentStyle">
			<slot />
		</div>
		<template #footer v-if="!hideFooter">
			<div class="dialog-footer" v-if="!$slots.footer">
				<div>
					<slot name="footerLeft" />
				</div>
				<span>
					<el-button @click="cancel" size="medium" v-if="!hideCancel">
						{{ cancelText || $t('common.cancel') }}
					</el-button>
					<el-button
						@click="confirm"
						type="primary"
						size="medium"
						:loading="confirmLoading"
						:disabled="disabled"
						v-if="!hideConfirm"
					>
						{{ confirmText || $t('common.confirm') }}
					</el-button>
				</span>
			</div>
			<slot v-else name="footer" />
		</template>
	</el-dialog>
</template>

<style lang="scss" scoped>
.dialog-content {
	padding: 24px;
}

.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}
</style>
